import { Pipe, PipeTransform } from '@angular/core';

import { clienteClassificacoesFaturamentosPositivas } from '../cliente-classificacao-faturamento-positiva';

@Pipe({
    name: 'clienteClassificacaoFaturamentoPositivaColor'
})
export class ClienteClassificacaoFaturamentoPositivaColorPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteClassificacoesFaturamentosPositivas.findIndex(cadastro => cadastro.id === value);
        if (index > -1) {
            return clienteClassificacoesFaturamentosPositivas[index].color;
        }
        return '';
    }
}
